import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/site';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-14">
          <div>
            <h4 className="font-heading text-xl font-bold mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">
                {siteInfo.name}
              </Link>
            </h4>
            <p className="text-sm text-background-600 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-400 uppercase tracking-wider mb-4">
              热门分类
            </h4>
            <div className="flex flex-col gap-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-400 uppercase tracking-wider mb-4">
              快捷链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="text-sm text-background-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">全部黑料</Link>
              <Link to="/category/celebrity" className="text-sm text-background-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">明星爆料</Link>
              <Link to="/category/internet-celebrity" className="text-sm text-background-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">网红黑料</Link>
              <Link to="/about" className="text-sm text-background-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-400 uppercase tracking-wider mb-4">
              联系我们
            </h4>
            <div className="flex flex-col gap-2 text-sm text-background-600">
              <p>邮箱：{siteInfo.email}</p>
              <p>电话：{siteInfo.phone}</p>
              <p>地址：{siteInfo.address}</p>
              <div className="flex items-center gap-3 mt-2">
                <a
                  href={siteInfo.socialLinks.weibo}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <span
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer"
                  title={`微信：${siteInfo.socialLinks.wechat}`}
                  aria-label="微信"
                >
                  <i className="ri-wechat-line text-sm"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-700">
            &copy; {currentYear} {siteInfo.name} 版权所有 | 本站内容仅供娱乐参考，不构成任何投资或法律建议
          </p>
          <div className="flex items-center gap-4 text-xs text-background-700">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}